export default "__VITE_ASSET__DjggYSIS__"